import { Injectable } from '@angular/core';
import { Device } from './device.model';
import { Tag } from '../utils.model';
import { TranslateFirebaseService } from 'src/app/service/utils/translate-firebase.service';

const deviceStorageKey = 'UPS-device';
const deviceApplicationsStorageKey = 'UPS-device-applicationsList';

@Injectable()
export class DeviceService {
  private _device: Device;
  private _temporaryDevice: Device;
  private _applicationsList: any;

  private _saveTemporaryDevice: boolean = false;

  constructor(private translate: TranslateFirebaseService) {
    const data = sessionStorage.getItem(deviceStorageKey);
    if (data != null) this.device = JSON.parse(data);
    else this.device = new Device();
  }

  get device(): Device {
    return this._device;
  }

  set device(device: Device) {
    this._device = device;
    sessionStorage.setItem(deviceStorageKey, JSON.stringify(device));
  }

  get temporaryDevice(): Device {
    return this._temporaryDevice;
  }

  set temporaryDevice(device: Device) {
    this._temporaryDevice = device;
  }

  get saveTemporaryDevice(): boolean {
    return this._saveTemporaryDevice;
  }

  set saveTemporaryDevice(value: boolean) {
    this._saveTemporaryDevice = value;
  }

  public get applicationsList(): Tag[] {
    let applicationsList = null
    if (this.translate.getTranslation('enum_device_application'))
     applicationsList = JSON.parse(this.translate.getTranslation('enum_device_application'));
    const data: Tag[] = JSON.parse(sessionStorage.getItem(deviceApplicationsStorageKey));
    if (applicationsList){
      this.applicationsList = applicationsList;
      return applicationsList;
    }
    else if (data){
      return data;
    } else return [];
  }

  public set applicationsList(value: Tag[]) {
    this._applicationsList = value;
    sessionStorage.setItem(deviceApplicationsStorageKey, JSON.stringify(value));
  }

  reset() {
    this.device = new Device();
    this.temporaryDevice = new Device();
    this.saveTemporaryDevice = false;
    sessionStorage.removeItem(deviceStorageKey);
  }
}
